import { useTranslation } from 'react-i18next';

export default function SafetySection() {
  const { t } = useTranslation();

  const safetyItems = [
    { icon: 'ri-shield-check-line', title: 'Payment Safety', desc: 'Secure payment methods with buyer protection' },
    { icon: 'ri-links-line', title: 'Link Safety', desc: 'Verified product links from trusted sellers' },
    { icon: 'ri-lock-password-line', title: 'Account Security', desc: 'Two-factor authentication and secure login' },
    { icon: 'ri-search-eye-line', title: 'Product Verification', desc: 'Detailed QC inspection before shipping' },
    { icon: 'ri-camera-line', title: 'QC Photos', desc: 'High-resolution quality check photographs' },
    { icon: 'ri-ship-line', title: 'Shipping Insurance', desc: 'Optional insurance for all shipments' },
  ];

  return (
    <section id="safety" className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=shield%20with%20check%20mark%20and%20padlock%20security%20symbol%20on%20clean%20light%20background%20studio%20product%20photography%20soft%20light%20minimal%20trust&width=800&height=600&seq=safety-1&orientation=landscape&nocache=true"
                alt="Safety Guide"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <span className="text-sm font-medium text-primary-600 uppercase tracking-widest mb-2 block">
              Trust & Security
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-4">
              {t('safety_title')}
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-8">
              {t('safety_desc')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {safetyItems.map((item) => (
                <div key={item.title} className="flex items-start gap-3 p-3 bg-background-100 rounded-lg border border-background-200/40">
                  <div className="w-8 h-8 rounded-md bg-primary-50 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} w-4 h-4 flex items-center justify-center text-primary-600`} />
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900">{item.title}</h4>
                    <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}